import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

const Logout = () => {
  const { logoutUser, userType } = useContext(AuthContext);
  
  // Get userType before logout (since logout clears it)
  const currentUserType = userType || localStorage.getItem('user_type');
  
  logoutUser();
  
  // Redirect based on user type
  const redirectPath = currentUserType === 'provider' ? '/provider-login' : '/login';
  
  return (
    <Navigate to={redirectPath} replace />
  );
}

export default Logout;